import React, { Component } from 'react';
import styled from 'styled-components';
import SelectFilter from '../Select/SelectFilter';

const LargeSelect = styled.div`
  display: flex;
  align-items: center;
`;

class SearchMultipleFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsOpen: false
    };
  }

  handleInputChange(value) {
    this.setState({ optionsOpen: value.length > this.props.minOpen });
  }

  render() {
    const { placeholder, options, customSearchFieldStyles, handleInputChange } =
      this.props;

    return (
      <LargeSelect>
        <SelectFilter
          options={options}
          placeholder={placeholder}
          containerStyles={`width: 100%; border: none!important; .selectIcon{margin-right: 10px}; input {
          box-sizing: content-box;
          width: 2px;
          background: 0px center;
          border: 0px;
          font-size: inherit;
          opacity: 1;
          outline: 0px;
          padding: 0px;
          color: inherit;
          height: 100%;
        }`}
          customStyles={{
            control: {
              border: 0,
              backgroundColor: 'rgba(39, 53, 68, 0.03)'
            },
            input: {
              color: '#aaa'
            },
            placeholder: {
              maxWidth: '80%'
            },
            ...customSearchFieldStyles
          }}
          onInputChange={(value) =>
            handleInputChange
              ? handleInputChange(value)
              : this.handleInputChange(value)
          }
          menuIsOpen={this.state.optionsOpen}
          dropdownIcon="magnifyingGlass"
          dropdownProps={{ marginRight: '20px', colorIcon: '#bcbdbe' }}
          {...this.props}
        />
      </LargeSelect>
    );
  }
}

export default SearchMultipleFields;
